function notifyAlbumsIndex(msg, type) {
  if (window.siteUi && typeof window.siteUi.showNotification === "function") {
    window.siteUi.showNotification({ message: msg, type: type || "info" })
  } else {
    window.alert(msg)
  }
}

function initTooltipsIn(container) {
  if (!window.bootstrap || !container) return
  container.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    if (!bootstrap.Tooltip.getInstance(el)) {
      new bootstrap.Tooltip(el)
    }
  })
}

function updatePhotoSelectionUi(root) {
  const countEl = document.getElementById("media-albums-photo-count")
  const clearBtn = document.getElementById("media-albums-photo-clear")
  if (!countEl || !root) return
  const n = root.querySelectorAll(".media-albums-photo-cb:checked").length
  countEl.textContent = String(n)
  if (clearBtn) clearBtn.disabled = n === 0
}

function selectedPhotoIds(root) {
  return Array.from(root.querySelectorAll(".media-albums-photo-cb:checked")).map((cb) =>
    parseInt(cb.value, 10)
  )
}

function csrfToken() {
  const tokenEl = document.querySelector('meta[name="csrf-token"]')
  return tokenEl ? tokenEl.getAttribute("content") : ""
}

/** Parse JSON body without relying on Content-Type (Rails may omit or vary the header). */
function parseFetchJsonResponse(r) {
  return r.text().then((text) => {
    const trimmed = text.trim()
    if (!trimmed) return { ok: r.ok, data: null, raw: text }
    try {
      return { ok: r.ok, data: JSON.parse(trimmed), raw: text }
    } catch {
      return { ok: r.ok, data: null, raw: text }
    }
  })
}

function initMediaAlbumsIndex() {
  const root = document.querySelector(".media-albums-index")
  if (!root) return
  // Both turbolinks:load and turbo:load may run; avoid duplicate listeners (double POST → false error after real create).
  if (root.dataset.mediaAlbumsIndexBound === "1") return
  root.dataset.mediaAlbumsIndexBound = "1"

  const listEl = document.getElementById("media-albums-list")
  const moveUrl = root.dataset.moveBatchUrl
  const createUrl = root.dataset.createUrl
  const albumTab = root.dataset.albumTab || "mine"

  const csrf = csrfToken()

  document.getElementById("media-albums-photo-clear")?.addEventListener("click", () => {
    root.querySelectorAll(".media-albums-photo-cb").forEach((cb) => {
      cb.checked = false
    })
    updatePhotoSelectionUi(root)
  })

  root.addEventListener("change", (e) => {
    if (e.target && e.target.classList.contains("media-albums-photo-cb")) updatePhotoSelectionUi(root)
  })

  root.addEventListener("click", (e) => {
    const btn = e.target.closest(".media-albums-move-here")
    if (!btn || !moveUrl) return
    e.preventDefault()
    const destId = btn.dataset.albumId
    if (!destId) return

    const ids = selectedPhotoIds(root)
    if (ids.length === 0) {
      notifyAlbumsIndex("Select one or more photos first.", "error")
      return
    }

    const body = new URLSearchParams()
    ids.forEach((id) => body.append("photo_ids[]", id))
    body.append("destination_album_id", destId)
    body.append("authenticity_token", csrf)

    btn.disabled = true

    fetch(moveUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "X-CSRF-Token": csrf,
        Accept: "application/json",
      },
      body: body.toString(),
      credentials: "same-origin",
    })
      .then(parseFetchJsonResponse)
      .then((res) => {
        if (res.data && res.data.success) {
          notifyAlbumsIndex(res.data.message, "success")
          window.location.reload()
          return
        }
        if (res.ok && res.data == null) {
          window.location.reload()
          return
        }
        notifyAlbumsIndex((res.data && res.data.message) || "Could not move photos.", "error")
      })
      .catch(() => {
        notifyAlbumsIndex("Could not move photos.", "error")
      })
      .finally(() => {
        btn.disabled = false
      })
  })

  const form = document.getElementById("media-albums-new-form")
  const modalEl = document.getElementById("media-albums-new-modal")
  if (form && createUrl && modalEl) {
    form.addEventListener("submit", (e) => {
      e.preventDefault()
      const submitBtn = document.getElementById("media-albums-new-submit")
      const alertEl = document.getElementById("media-albums-new-alert")
      const titleInput = document.getElementById("media_albums_new_title")
      const title = titleInput ? titleInput.value.trim() : ""
      if (!title) {
        if (alertEl) {
          alertEl.textContent = "Enter a title."
          alertEl.classList.remove("d-none")
        }
        return
      }
      if (alertEl) {
        alertEl.classList.add("d-none")
        alertEl.textContent = ""
      }

      const body = new URLSearchParams()
      body.append("media_album[title]", title)
      body.append("album_tab", albumTab)
      body.append("authenticity_token", csrf)

      if (submitBtn) submitBtn.disabled = true

      fetch(createUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          "X-CSRF-Token": csrf,
          Accept: "application/json",
        },
        body: body.toString(),
        credentials: "same-origin",
      })
        .then(parseFetchJsonResponse)
        .then((res) => {
          const data = res.data
          const serverFail = data && data.success === false
          const serverSuccess =
            data &&
            !serverFail &&
            (data.success === true || (res.ok && data.album != null && data.album.id != null))

          if (serverSuccess) {
            const rowHtml = data.html
            const hasRow = listEl && rowHtml && String(rowHtml).trim().length > 0
            if (hasRow) {
              try {
                listEl.insertAdjacentHTML("afterbegin", rowHtml)
                const firstRow = listEl.firstElementChild
                if (firstRow) initTooltipsIn(firstRow)
                form.reset()
                notifyAlbumsIndex("Album created.", "success")
                const modalInst = window.bootstrap?.Modal?.getInstance(modalEl)
                if (modalInst) modalInst.hide()
              } catch (err) {
                // Server already created the album; row HTML can throw (e.g. duplicate ids, parser quirks).
                console.warn("[media_albums_index] could not insert new album row:", err)
                const modalInst = window.bootstrap?.Modal?.getInstance(modalEl)
                if (modalInst) modalInst.hide()
                window.location.reload()
              }
            } else {
              const modalInst = window.bootstrap?.Modal?.getInstance(modalEl)
              if (modalInst) modalInst.hide()
              window.location.reload()
            }
            return
          }

          if (serverFail) {
            const msg =
              (data && data.message) || (data && data.errors && data.errors.join(", ")) || "Could not create album."
            if (alertEl) {
              alertEl.textContent = msg
              alertEl.classList.remove("d-none")
            } else {
              notifyAlbumsIndex(msg, "error")
            }
            return
          }

          // 2xx but body was not JSON or did not include success — album may still have been saved.
          if (res.ok) {
            const modalInst = window.bootstrap?.Modal?.getInstance(modalEl)
            if (modalInst) modalInst.hide()
            window.location.reload()
            return
          }

          const msg =
            (data && data.message) || (data && data.errors && data.errors.join(", ")) || "Could not create album."
          if (alertEl) {
            alertEl.textContent = msg
            alertEl.classList.remove("d-none")
          } else {
            notifyAlbumsIndex(msg, "error")
          }
        })
        .catch(() => {
          if (alertEl) {
            alertEl.textContent = "Could not create album."
            alertEl.classList.remove("d-none")
          } else {
            notifyAlbumsIndex("Could not create album.", "error")
          }
        })
        .finally(() => {
          if (submitBtn) submitBtn.disabled = false
        })
    })

    modalEl.addEventListener("hidden.bs.modal", () => {
      const alertEl = document.getElementById("media-albums-new-alert")
      if (alertEl) {
        alertEl.classList.add("d-none")
        alertEl.textContent = ""
      }
    })
  }

  updatePhotoSelectionUi(root)
}

document.addEventListener("turbolinks:load", initMediaAlbumsIndex)
document.addEventListener("turbo:load", initMediaAlbumsIndex)
